import { default as _91_46_46_46route_93YfbM34WvaXMeta } from "/builds/webcontact/lossburg/pages/[...route].vue?macro=true";
import { default as indexYjwCoJycqKMeta } from "/builds/webcontact/lossburg/pages/de/index.vue?macro=true";
import { default as examplebFR31kXfldMeta } from "/builds/webcontact/lossburg/pages/example.vue?macro=true";
import { default as component_45stubi2Z1BhcuM7Meta } from "/builds/webcontact/lossburg/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubi2Z1BhcuM7 } from "/builds/webcontact/lossburg/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "route",
    path: "/:route(.*)*",
    component: () => import("/builds/webcontact/lossburg/pages/[...route].vue")
  },
  {
    name: "de",
    path: "/de",
    component: () => import("/builds/webcontact/lossburg/pages/de/index.vue")
  },
  {
    name: "example",
    path: "/example",
    component: () => import("/builds/webcontact/lossburg/pages/example.vue")
  },
  {
    name: component_45stubi2Z1BhcuM7Meta?.name,
    path: "/",
    component: component_45stubi2Z1BhcuM7
  }
]